import {
    Component,
    inject,
    Input,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DATE_FORMAT, YES_NO_OPTIONS } from 'src/app/shared/constants';
import {
    DxButtonModule,
    DxDateBoxModule,
    DxFormModule,
    DxLoadPanelModule,
    DxRadioGroupModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxToolbarModule,
    DxValidationGroupModule,
    DxValidatorModule,
} from 'devextreme-angular';
import {
    AppointmentDto,
    DataSources,
    ShuntLocationType,
    TrailerType,
} from '@services';
import { DxCheckBoxModule } from 'devextreme-angular/ui/check-box';
import EnumUtils from 'src/app/shared/enum-utils';
import { CustomStore } from 'devextreme-aspnet-data-nojquery';
import { TrailerTypePipe } from 'src/app/pipes/trailer-type.pipe';

@Component({
    selector: 'app-guard-house',
    imports: [
        CommonModule,
        DxToolbarModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxValidationGroupModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxSelectBoxModule,
        DxDateBoxModule,
        DxScrollViewModule,
        DxFormModule,
        DxRadioGroupModule,
        DxTextAreaModule,
        DxCheckBoxModule,
    ],
    providers: [TrailerTypePipe],
    templateUrl: './guard-house.component.html',
})
export class GuardHouseComponent implements OnChanges {
    @Input() appointment: AppointmentDto;
    @Input() carrierDataSource: any;
    @Input() isReadOnly: boolean = false;

    dataSources = inject(DataSources);
    trailerTypePipe = inject(TrailerTypePipe);
    shuntLocationDataSource: CustomStore;
    guardHouseLocation = ShuntLocationType;

    shuntLocationOptions = EnumUtils.getEnumOptions(ShuntLocationType);
    trailerTypeOptions = EnumUtils.getEnumOptions(TrailerType, (v) =>
        this.trailerTypePipe.transform(v),
    );

    public dateFormat = DATE_FORMAT;
    public isValidationEnabled = true;

    public yesNoOptions = YES_NO_OPTIONS;

    ngOnChanges(changes: SimpleChanges) {
        if (changes.appointment.currentValue.guardHouseLocation !== null &&
            changes.appointment.currentValue.guardHouseLocation !==
                changes.appointment.previousValue?.guardHouseLocation
        ) {
            this.loadShuntLocations();
            this.onValueChanged(this.appointment.guardHouseLocationId);
        }
    }

    onLocationTypeChanged(e: any) {
        this.onValueChanged(undefined);
        this.loadShuntLocations();
    }

    loadShuntLocations() {
        this.shuntLocationDataSource = this.dataSources.shuntLocationOptions(
            this.appointment.guardHouseLocation as ShuntLocationType,
            this.appointment.guardHouseLocationId,
        );
    }

    onValueChanged(guardHouseLocationId: any | undefined) {
        this.appointment.guardHouseLocationId = guardHouseLocationId;
    }

    validate = (params: { value: any }): boolean => {
        if (!this.isValidationEnabled) return true;
        return (
            params.value !== null &&
            params.value !== undefined &&
            params.value !== ''
        );
    };
}
